import { surveyApi } from "./base";

export const surveyCustomFieldsApi = surveyApi
  .enhanceEndpoints({ addTagTypes: ["Survey"] })
  .injectEndpoints({
    endpoints: (build) => ({
      updateCustomField: build.mutation({
        query: ({ data }) => ({
          url: `/customfields`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (_result, _error, { surveyId }) => [
          { type: "Survey", id: surveyId },
        ],
      }),
      addCustomField: build.mutation({
        query: ({ data }) => ({
          url: `/customfields`,
          method: "POST",
          body: data,
        }),
        invalidatesTags: (_result, _error, { surveyId }) => [
          { type: "Survey", id: surveyId },
        ],
      }),
      deleteCustomField: build.mutation({
        query: ({ id }) => ({
          url: `/customfields/${id}`,
          method: "DELETE",
          responseHandler: "text", // Handle response as text
        }),
        invalidatesTags: (_result, _error, { surveyId }) => [
          { type: "Survey", id: surveyId },
        ],
      }),
    }),
  });

export const {
  useUpdateCustomFieldMutation,
  useAddCustomFieldMutation,
  useDeleteCustomFieldMutation,
} = surveyCustomFieldsApi;
